import {mapState,mapActions} from 'vuex'
import {tokenAndRoute} from "../utils/tokenAndRoute";
import {toFormData} from "../utils/toFormData";

export const combineThings = {
  mixins: [tokenAndRoute, toFormData],
  computed: {
    ...mapState({
      activeSectionThings: state => state.things.activeSectionThings
    })
  },
  methods: {
    ...mapActions({
      updateThing: 'things/updateDevice',
      updateGroup: 'things/updateDeviceGroup',
      getOwnedDevices: 'things/getDevices',
      // getAssignedDevices: 'things/getAssignedDevices',
      getProjects: 'projects/getProjects'
    }),
    async updateGroupMerged(val, item) {
      //val = id
      //item = thing
      let data = {
        //access_token: this.token,
        parent_group_id: val,
        group_id: item.id
      };
      let formData = this.toFormData(data);
      await this.updateGroup({data: formData, token: this.token});
    },
    async updateThingMerged(val,item) {
      let data = {
        //access_token:  this.token,
        group_id: val,
        device_id: item.id
      };
      let formData = this.toFormData(data);

      await this.updateThing({data: formData, token: this.token});
    },
    async updateThings() {
      if (this.$route.name === 'ThingsInProject' || this.$route.name === 'ThingsInProjectItem') {
        await this.getProjects()

        this.getOwnedDevices({token: this.token})
      }
    }
  },

}
